<template>
   <div>
      <form class="form-signin" @submit.prevent="login">
         <!-- <h1 class="h3 mb-3 font-weight-normal">請先登入</h1>
         <label for="inputEmail" class="sr-only">Email</label>
         <input
            type="email"
            id="inputEmail"
            class="form-control"
            placeholder="Email address"
            v-model="member.membername"
            required
            autofocus
         />
         <label for="inputPassword" class="sr-only">密碼</label>
         <input
            type="password"
            id="inputPassword"
            class="form-control"
            v-model="member.password"
            placeholder="Password"
            required
         />
         <div class="checkbox mb-3">
            <label>
               <input type="checkbox" value="remember-me" /> Remember me
            </label>
         </div>-->
         <br />
         <br />
         <br />
         <br />
         <br />
         <br />
         <p class="mt-5 mb-3 text-muted">系統登入中....請稍後</p>
      </form>
   </div>
</template>

<script>
export default {
   name: "HelloWorld",
   data() {
      return {
         member: {
            suuid: "",
            accessToken: "",
         },
         accessToken: "",
      };
   },
   methods: {
      login() {
         var vm = this;
         var suuid = vm.member.suuid;
         var accessToken = vm.member.accessToken;
         var url = "/members/check/" + suuid;

         var opt = {
            accessToken: accessToken,
         };
         // console.log("url:", url);
         // console.log("opt:", opt);
         this.$accountsServiceInstance
            .post(url, opt)
            .then((response) => {
               this.member = response.data;
               this.member.accessToken = accessToken;
               localStorage.setItem("member", JSON.stringify(this.member));
               if (this.member.is_login) {
                  vm.$router.push({ path: "/customer/customer_order" });
               }else{
                  vm.$router.push({ path: "../login" });
               }
            })
            .catch((err) => console.log(err));
      },
   },
   created() {
      
      this.member.suuid = this.$route.query.member_suuid;
      this.member.accessToken = this.$route.query.access_token;
      this.login();

   },
};
</script>

<style scoped>
html,
body {
   height: 100%;
}

body {
   display: -ms-flexbox;
   display: flex;
   -ms-flex-align: center;
   align-items: center;
   padding-top: 40px;
   padding-bottom: 40px;
   background-color: #f5f5f5;
}

.form-signin {
   width: 100%;
   max-width: 330px;
   padding: 15px;
   margin: auto;
}
.form-signin .checkbox {
   font-weight: 400;
}
.form-signin .form-control {
   position: relative;
   box-sizing: border-box;
   height: auto;
   padding: 10px;
   font-size: 16px;
}
.form-signin .form-control:focus {
   z-index: 2;
}
.form-signin input[type="email"] {
   margin-bottom: -1px;
   border-bottom-right-radius: 0;
   border-bottom-left-radius: 0;
}
.form-signin input[type="password"] {
   margin-bottom: 10px;
   border-top-left-radius: 0;
   border-top-right-radius: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/LineLogin.vue